import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { MediaQuery } from '@grandvisionhq/common';
import { StepForm } from '@grandvisionhq/configurator';
import { useIntl } from '@grandvisionhq/state';
import PrescriptionColumn from '../PrescriptionColumn/PrescriptionColumn.js';
import { PupillaryDistanceLinkContainer } from '../PupillaryDistanceLink/PupillaryDistanceLinkContainer.js';

const PrescriptionForm = (_param)=>{
    var { idExtension , className , prescription , setLeftParameter , setRightParameter , opticalParameters , prescriptionValidationState , isSubmitted , isDisabled , onSubmit  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "idExtension",
        "className",
        "prescription",
        "setLeftParameter",
        "setRightParameter",
        "opticalParameters",
        "prescriptionValidationState",
        "isSubmitted",
        "isDisabled",
        "onSubmit"
    ]);
    const { getLabel  } = useIntl();
    const isPhone = MediaQuery.useIsPhone();
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(StepForm, {
        className: classnames('prescription-form', className),
        "data-t": rest['data-t'],
        onSubmit: onSubmit
    }, /*#__PURE__*/ React__default.createElement(PrescriptionColumn, {
        className: "prescription-form__column",
        id: `right-configurator-${idExtension}`,
        columnTitle: getLabel(`products.glasses.rightEye`),
        parameters: opticalParameters,
        selectedValues: prescription.right,
        validations: prescriptionValidationState === null || prescriptionValidationState === void 0 ? void 0 : prescriptionValidationState.right,
        showValidation: isSubmitted,
        onAttributeChange: setRightParameter,
        isDisabled: isDisabled
    }), isPhone && /*#__PURE__*/ React__default.createElement(PupillaryDistanceLinkContainer, {
        className: "prescription-form__pd-link"
    }), /*#__PURE__*/ React__default.createElement(PrescriptionColumn, {
        className: "prescription-form__column",
        id: `left-configurator-${idExtension}`,
        columnTitle: getLabel(`products.glasses.leftEye`),
        parameters: opticalParameters,
        selectedValues: prescription.left,
        validations: prescriptionValidationState === null || prescriptionValidationState === void 0 ? void 0 : prescriptionValidationState.left,
        showValidation: isSubmitted,
        onAttributeChange: setLeftParameter,
        hideSelectLabels: true,
        isDisabled: isDisabled
    })), /*#__PURE__*/ React__default.createElement(PupillaryDistanceLinkContainer, {
        className: "prescription-form__pd-link"
    }));
};
var PrescriptionForm$1 = PrescriptionForm;

export { PrescriptionForm$1 as default };
//# sourceMappingURL=PrescriptionForm.js.map
